import api from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

import { INextSchedulesData, INextSchedule } from './types'

export const fetchNextSchedules = async (): Promise<INextSchedule[]> => {
  try {
    const { data } = await api.get<INextSchedulesData>(
      apiEndpoints.ME_SCHEDULES_NEXT
    )

    return data.schedules.map((schedule) => ({
      id: schedule.id,
      session: schedule.session,
      startDate: schedule.start_date,
      endDate: schedule.end_date,
      virtualRoomHash: schedule.virtual_room_hash,
      planGroupName: schedule.plan_group_name,
      planGroupCode: schedule.plan_group_code,
      planName: schedule.plan_name,
      statusName: schedule.status_name,
      statusCode: schedule.status_code,
      patientFullName: schedule.patient_full_name,
      professionalDocumentTypeName: schedule.professional_document_type_name,
      professionalFullName: schedule.professional_full_name,
      professionalPictureUrl: schedule.professional_picture_url,
      professionalFriendlyUrl: schedule.professional_friendly_url,
      professionalProfileCode: schedule.professional_profile_code,
      professionalDocumentValue: schedule.professional_document_value,
      medicalReturn: schedule.medical_return,
      rescheduleEnabled: schedule.reschedule_enabled,
      cancellationEnabled: schedule.cancellation_enabled,
      productCode: schedule.product_code,
      professionalUsername: schedule.professional_username,
      planCode: schedule.plan_code,
      tokenHasBeenFilled: schedule.token_has_been_filled,
    }))
  } catch (error) {
    let message = 'Erro ao buscar próximas consultas'
    if (error instanceof Error) {
      message = error?.message
    } else {
      message = String(error)
    }

    return Promise.reject(message)
  }
}
